import React from 'react'
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { costInvoiceStatusVariant } from '@/lib/status-variants'
import { formatIsoDate } from '../../schedule/lib/format'
import type { LedgerRow } from '../lib/invoices'
import { INVOICE_STATUS_KEY, LEDGER_KIND_KEY } from '../lib/labels'
import { formatMoney } from '../lib/money'

interface Props { rows: LedgerRow[]; currency: string; locale: string; onOpen: (row: LedgerRow) => void }

const LedgerTable: React.FC<Props> = ({ rows, currency, locale, onOpen }) => {
  const { t } = useTranslation()
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-28">{t('CostControl_ledger_col_date')}</TableHead>
            <TableHead>{t('CostControl_ledger_col_document')}</TableHead>
            <TableHead>{t('CostControl_ledger_col_detail')}</TableHead>
            <TableHead>{t('CostControl_ledger_col_counterparty')}</TableHead>
            <TableHead className="w-40">{t('CostControl_contract_field_status')}</TableHead>
            <TableHead className="w-40 text-right">{t('CostControl_ledger_col_amount')}</TableHead>
            <TableHead className="w-40 text-right">{t('CostControl_ledger_col_payable')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={`${r.kind}:${r.id}`} className="cursor-pointer" onClick={() => onOpen(r)}>
              <TableCell className="whitespace-nowrap text-sm">{formatIsoDate(t, r.date)}</TableCell>
              <TableCell>
                <button type="button" className="text-left font-medium text-primary hover:underline" onClick={(e) => { e.stopPropagation(); onOpen(r) }}>{r.title}</button>
                <div className="text-xs text-muted-foreground">{t(LEDGER_KIND_KEY[r.kind])}</div>
              </TableCell>
              <TableCell className="text-sm">{r.detail}</TableCell>
              <TableCell className="text-sm">{r.counterparty ?? '—'}</TableCell>
              <TableCell>{r.status && <Badge variant={costInvoiceStatusVariant(r.status)}>{t(INVOICE_STATUS_KEY[r.status])}</Badge>}</TableCell>
              <TableCell className="text-right tabular-nums">{formatMoney(r.amount, { locale, currency })}</TableCell>
              <TableCell className="text-right tabular-nums">{r.payable === null ? '—' : formatMoney(r.payable, { locale, currency })}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
export default LedgerTable
